module.exports = __webpack_public_path__ + "static/1256836165.86fba410.jpg";